import * as React from "react";
import { cn } from "./cn";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  invalid?: boolean;
};

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, invalid, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        "h-12 w-full rounded-[var(--radius-sm)] border-[1.5px] px-4 text-[15px]",
        "font-satoshi font-medium text-ink placeholder:text-ash",
        "bg-mist border-smoke outline-none transition-colors",
        "focus:border-lime focus:bg-paper",
        "disabled:cursor-not-allowed disabled:opacity-60",
        invalid && "border-danger focus:border-danger",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";
